import request from '@/utils/request'

const http = request()

export const listLskProject = params => http.post('/project/lsk/page', params)

export const viewLskPrj = id => http.post(`/project/lsk/${id}`)

export const viewPrj = (projectId, isDetail = false) => (isDetail ? http.post('/project/lsk/detail', { projectId }) : http.post('/project/lsk/view', { projectId }))

export const reviewPrj = projectId => http.post('/project/lsk/review', { projectId })

export const auditLskPrj = params => http.post('/project/lsk/audit', params)

export const stopLskPrj = projectId => http.post('/project/lsk/stop', { projectId })

export const concludeLskPrj = projectId => http.post('/project/lsk/conclude', { projectId })

export const closeLskPrj = projectId => http.post('/project/lsk/close', { projectId })

export const saveLskProtocol = params => http.raw(params.nextStep ? '/project/lsk/protocol/submit' : '/project/lsk/protocol/save', params)

export const setconstructor = (projectId, uid) => http.post('/project/lsk/setconstructor', { projectId, uid })

export const saveBudget = params => http.raw(params.nextStep ? '/project/lsk/budget/submit' : '/project/lsk/budget/save', params)

export const getBudget = projectId => http.post('/project/lsk/budget', { projectId })
